enum AccountType {
  DefaultUser = 0,
  CastingDirector = 1,
  Performer = 2,
  Agent = 3,
  CastingSearchOnly = 4,
}

export default AccountType;
